/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WebApiCustomListFieldsDtoCustomFieldUploadDto,
  WebApiCustomListFieldsDtoSaveCustomFieldSettingsDto,
  WebApiModelsCustomListField,
} from '../models';
import {
    WebApiCustomListFieldsDtoCustomFieldUploadDtoFromJSON,
    WebApiCustomListFieldsDtoCustomFieldUploadDtoToJSON,
    WebApiCustomListFieldsDtoSaveCustomFieldSettingsDtoFromJSON,
    WebApiCustomListFieldsDtoSaveCustomFieldSettingsDtoToJSON,
    WebApiModelsCustomListFieldFromJSON,
    WebApiModelsCustomListFieldToJSON,
} from '../models';

export interface ApiCustomListFieldCreateCustomListUploadTemplateListIdPostRequest {
    listId: number;
}

export interface ApiCustomListFieldGetCustomFieldsListIdGetRequest {
    listId: number;
}

export interface ApiCustomListFieldGetMemberUploadFieldsListIdGetRequest {
    listId: number;
}

export interface ApiCustomListFieldSaveMemberFieldsPostRequest {
    webApiCustomListFieldsDtoSaveCustomFieldSettingsDto?: WebApiCustomListFieldsDtoSaveCustomFieldSettingsDto;
}

/**
 * 
 */
export class CustomListFieldApi extends runtime.BaseAPI {

    /**
     * 
     */
    async apiCustomListFieldCreateCustomListUploadTemplateListIdPostRaw(requestParameters: ApiCustomListFieldCreateCustomListUploadTemplateListIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.listId === null || requestParameters.listId === undefined) {
            throw new runtime.RequiredError('listId','Required parameter requestParameters.listId was null or undefined when calling apiCustomListFieldCreateCustomListUploadTemplateListIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/CustomListField/CreateCustomListUploadTemplate/{listId}`.replace(`{${"listId"}}`, encodeURIComponent(String(requestParameters.listId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async apiCustomListFieldCreateCustomListUploadTemplateListIdPost(requestParameters: ApiCustomListFieldCreateCustomListUploadTemplateListIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiCustomListFieldCreateCustomListUploadTemplateListIdPostRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async apiCustomListFieldGetCustomFieldsListIdGetRaw(requestParameters: ApiCustomListFieldGetCustomFieldsListIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiModelsCustomListField>>> {
        if (requestParameters.listId === null || requestParameters.listId === undefined) {
            throw new runtime.RequiredError('listId','Required parameter requestParameters.listId was null or undefined when calling apiCustomListFieldGetCustomFieldsListIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/CustomListField/GetCustomFields/{listId}`.replace(`{${"listId"}}`, encodeURIComponent(String(requestParameters.listId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiModelsCustomListFieldFromJSON));
    }

    /**
     * 
     */
    async apiCustomListFieldGetCustomFieldsListIdGet(requestParameters: ApiCustomListFieldGetCustomFieldsListIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiModelsCustomListField>> {
        const response = await this.apiCustomListFieldGetCustomFieldsListIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiCustomListFieldGetMemberUploadFieldsListIdGetRaw(requestParameters: ApiCustomListFieldGetMemberUploadFieldsListIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiCustomListFieldsDtoCustomFieldUploadDto>>> {
        if (requestParameters.listId === null || requestParameters.listId === undefined) {
            throw new runtime.RequiredError('listId','Required parameter requestParameters.listId was null or undefined when calling apiCustomListFieldGetMemberUploadFieldsListIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/CustomListField/GetMemberUploadFields/{listId}`.replace(`{${"listId"}}`, encodeURIComponent(String(requestParameters.listId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiCustomListFieldsDtoCustomFieldUploadDtoFromJSON));
    }

    /**
     * 
     */
    async apiCustomListFieldGetMemberUploadFieldsListIdGet(requestParameters: ApiCustomListFieldGetMemberUploadFieldsListIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiCustomListFieldsDtoCustomFieldUploadDto>> {
        const response = await this.apiCustomListFieldGetMemberUploadFieldsListIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiCustomListFieldSaveMemberFieldsPostRaw(requestParameters: ApiCustomListFieldSaveMemberFieldsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/CustomListField/SaveMemberFields`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiCustomListFieldsDtoSaveCustomFieldSettingsDtoToJSON(requestParameters.webApiCustomListFieldsDtoSaveCustomFieldSettingsDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * 
     */
    async apiCustomListFieldSaveMemberFieldsPost(requestParameters: ApiCustomListFieldSaveMemberFieldsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.apiCustomListFieldSaveMemberFieldsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
